import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import EnterprisePageTemplateWrapper from 'bundles/unified-common/pageUtils/EnterprisePageTemplateWrapper';
import EnterprisePageGuard from 'bundles/unified-description-page-common/pages/enterprise/EnterprisePageGuard';
import EnterpriseSpecializationPageRootContent from 'bundles/unified-description-page-common/pages/enterprise/specialization/EnterpriseSpecializationPageRootContent';
import EnterpriseAdminEnrollmentDataProvider from 'bundles/unified-description-page-common/providers/enterprise/EnterpriseAdminEnrollmentDataProvider';
import { EnterpriseLearnerFlowOptimizationDataProvider } from 'bundles/unified-description-page-common/providers/enterprise/EnterpriseLearnerFlowOptimizationDataProvider';
import EnterpriseSpecializationPageDataProvider from 'bundles/unified-description-page-common/providers/enterprise/pages/EnterpriseSpecializationPageDataProvider';

const EnterpriseSpecializationPageRoot = () => {
  return (
    <div data-e2e="unified-specializations-page">
      <EnterpriseSpecializationPageDataProvider>
        <EnterprisePageTemplateWrapper>
          <EnterprisePageGuard>
            <EnterpriseAdminEnrollmentDataProvider>
              <EnterpriseLearnerFlowOptimizationDataProvider>
                <EnterpriseSpecializationPageRootContent />
              </EnterpriseLearnerFlowOptimizationDataProvider>
            </EnterpriseAdminEnrollmentDataProvider>
          </EnterprisePageGuard>
        </EnterprisePageTemplateWrapper>
      </EnterpriseSpecializationPageDataProvider>
    </div>
  );
};

export default compose(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'unified_description_page',
      page: 'enterprise_specialization_page',
    },
  }))
)(EnterpriseSpecializationPageRoot);
